/** Numeric wire values — mirrors EPN.TaxCompliance.Api's own `TaxFormCode` enum exactly. */
export const TaxFormCode = { Form941: 1, Form940: 2 } as const;
export const taxFormCodeLabels: Record<number, string> = { 1: 'Form 941 (Quarterly)', 2: 'Form 940 (Annual)' };

export interface TaxLiabilityResponse {
  id: string;
  companyId: string;
  formCode: number;
  taxYear: number;
  quarter: number | null;
  totalAmount: number;
  totalWages: number;
  numberOfEmployees: number;
  sourcePayrollRunIds: string[];
  calculatedByEmailSnapshot: string;
  calculatedAtUtc: string;
}

/** `status` is the raw wire string ("Submitted"/"Settled"/"Failed") — matches this project's convention
 * of leaving status-like fields as descriptive strings rather than numeric wire enums. */
export interface TaxDepositResponse {
  id: string;
  companyId: string;
  taxLiabilityId: string;
  status: string;
  providerFileId: string | null;
  failureReason: string | null;
  initiatedByEmailSnapshot: string;
  initiatedAtUtc: string;
  submittedAtUtc: string | null;
  settledAtUtc: string | null;
  failedAtUtc: string | null;
}
